module.exports = __webpack_public_path__ + "img/writerPage_toux.e9b8ac60.png";